import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Card,
    CardActions,
    CardContent,
    Chip,
    Divider,
    Stack,
    Typography,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

export default function CustomerGroupList({ groups, customerIndexById, customerList, onEdit, onDeleteAsk }) {
    return (
        <Stack spacing={2}>
            {groups.map((group) => (
                <Accordion key={group.key} defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                                {group.key}
                            </Typography>
                            <Chip size="small" label={group.customers.length} />
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid2 container spacing={2}>
                            {group.customers.map((customer) => {
                                const originalIndex = customer?.id
                                    ? customerIndexById.get(customer.id)
                                    : customerList.findIndex((item) => item === customer);
                                return (
                                    <Grid2 key={customer.id} xs={12} sm={6} md={4}>
                                        <Card
                                            sx={{
                                                borderRadius: 3,
                                                border: (theme) =>
                                                    `1px solid ${
                                                        theme.palette.mode === "dark" ? theme.palette.divider : "#ffe0b2"
                                                    }`,
                                                boxShadow: (theme) =>
                                                    theme.palette.mode === "dark"
                                                        ? "0 6px 24px rgba(0,0,0,0.45)"
                                                        : "0 6px 24px rgba(0,0,0,0.06)",
                                                background: (theme) =>
                                                    theme.palette.mode === "dark"
                                                        ? theme.palette.background.paper
                                                        : "linear-gradient(0deg, #fff8e1 0%, #fff 60%)",
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <CardContent sx={{ flexGrow: 1 }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    fontWeight={700}
                                                    noWrap
                                                    title={`${customer.name || ""} ${customer.lastname || ""}`.trim()}
                                                >
                                                    {`${customer.name || ""} ${customer.lastname || ""}`.trim() || "—"}
                                                </Typography>

                                                <Stack direction="row" spacing={1} sx={{ mt: 0.75 }} flexWrap="wrap">
                                                    {customer?.email && (
                                                        <Chip size="small" label={customer.email} variant="outlined" />
                                                    )}
                                                    {customer?.phone && <Chip size="small" label={customer.phone} />}
                                                </Stack>

                                                <Divider sx={{ my: 1.25 }} />

                                                <Typography variant="body2" color="text.secondary">
                                                    {customer.addresses?.length || 0} Adresse(n) · {customer.bankConnections?.length || 0} Bankverbindung(en)
                                                </Typography>
                                            </CardContent>
                                            <CardActions sx={{ pt: 0, pb: 2, px: 2, gap: 1 }}>
                                                <Button size="small" onClick={() => onEdit(originalIndex)}>
                                                    Bearbeiten
                                                </Button>
                                                <Button size="small" color="error" onClick={() => onDeleteAsk(customer, originalIndex)}>
                                                    Löschen
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid2>
                                );
                            })}
                        </Grid2>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Stack>
    );
}
